<template>
  <div class="line-point">
    <drag-zone :list="list" @sort="onSort" item-class="point-item-box" class="point-list" v-if="list.length">
      <template #default="{ item, index }">
        <div class="point-item">
          <div class="point-title">
            <span>点位{{ index + 1 }}</span>
            <a-icon type="form" class="edit-icon" @click.stop="editPoint(item, index)" />
            <a-icon type="delete" class="delete-icon" @click.stop="deletePoint(index)" />
          </div>
          <div class="point-name">名称：{{ item.name }}</div>
          <div class="point-address">地址：{{ item.location && item.location.address }}</div>
        </div>
      </template>
    </drag-zone>
    <a-button type="primary" @click="add"> 新增 </a-button>
    <a-modal
      :maskClosable="false"
      v-model="visible"
      :width="520"
      :title="`${formData.id ? '编辑' : '添加'}点位`"
      ok-text="确认"
      cancel-text="取消"
      @ok="confirm"
    >
      <a-form-model
        class="item-form"
        ref="editForm"
        :model="formData"
        :rules="rules"
        layout="vertical"
        labelAlign="left"
      >
        <a-form-model-item label="点位名称" prop="name">
          <a-input v-model="formData.name" placeholder="请输入点位名称"> </a-input>
        </a-form-model-item>
        <a-form-model-item label="点位地址" prop="location">
          <coordinate-picker v-model="formData.location"></coordinate-picker>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import DragZone from "../components/drag-zone.vue";
import { clone, randomString } from "../common/js/tool";

export default {
  name: "LinePoint",
  components: {
    DragZone,
  },
  model: {
    event: "change",
  },
  props: {
    value: Array,
  },
  data() {
    return {
      list: [],
      visible: false,
      editIndex: -1,
      formData: {},
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        location: [{ required: true, message: "请选择地址", trigger: "change" }],
      },
    };
  },
  watch: {
    value() {
      this.setValue();
    },
  },
  created() {
    this.setValue();
  },
  methods: {
    setValue() {
      if (this.value) {
        this.list = this.value.map((item) => {
          return {
            ...item,
            key: item.key || item.id,
            location: item.location || {
              latLng: item.lat_lon,
              address: item.address,
              name: item.name,
            },
          };
        });
      } else {
        this.list = [];
      }
    },
    showModal() {
      this.visible = true;
    },
    hideModal() {
      this.visible = false;
    },
    dispatch() {
      this.$emit("change", this.list);
    },
    confirm() {
      this.$refs.editForm.validate((flag) => {
        if (flag) {
          const formData = clone(this.formData);
          if (this.editIndex >= 0) {
            // 编辑
            this.list.splice(this.editIndex, 1, formData);
          } else {
            // 新增
            this.list.push(formData);
          }
          this.hideModal();
          this.dispatch();
        }
      });
    },
    add() {
      this.editIndex = -1;
      this.formData = { key: randomString() };
      this.showModal();
    },
    editPoint(item, index) {
      this.editIndex = index;
      this.formData = item;
      this.showModal();
    },
    deletePoint(index) {
      this.list.splice(index, 1);
      this.dispatch();
    },
    onSort(list) {
      this.list = list;
      this.dispatch();
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .point-list {
  .point-item-box {
    &:not(:first-of-type) {
      margin-top: 12px;
    }
  }
}
.point-item {
  border: 1px solid #e8e8e8;
  padding: 6px 12px;
  border-radius: 4px;
}
.point-title {
  display: flex;
  align-items: center;
}
.delete-icon,
.edit-icon {
  margin-left: 12px;
  font-size: 18px;
}
</style>
